import { LanguageDraft } from "./language-models.interface";
export interface Profile {
  uid: string;
  email: string;
  firstname: string;
  lastname: string;
  createdAt?: number;
  status?: UserQuestionResponse[]; // should be a dictionary// deprecated
  currentLesson?: number;
  currentQuestion?: number;
  anonymous?: boolean; // deprecated
  bypassed?: boolean; // deprecated
  unlocked: object;
  isInstructor?: boolean; // deprecated
  instructor?: any;
  totalMessages?: number; // deprecated
  toured?: boolean;
  oldUID?: string; // deprecated
  lastUpdated?: number;
  preferences?: Preferences;
  entityId?: string; // when a user signs up under a church, this will be set to the churches entity id
  city?: string;
  zipcode?: string;
  country?: string;
  emailConf?: any; // only pressent if created by a bot
  passwordConf?: any; // if this is present, the server will delete the profile
  organization?: string; // id of org
  confirmations?: object | unknown[] | any;
  outreachCreated?: boolean;
}

export interface Preferences {
  notifications?: Notifications;
  language?: LanguageDraft;
}

export interface Notifications {
  emailsEnabled?: boolean;
  emailsEnabledTouched?: boolean;
}

export const createPreferences = (): Preferences => {
  const prefs = {} as Preferences;
  prefs.notifications = {} as Notifications;
  prefs.notifications.emailsEnabled = true;
  prefs.notifications.emailsEnabledTouched = false;
  return prefs;
};

export interface LoginUser {
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  // phone: string;
  city: string;
  zipcode: string;
  country: string;
  emailConf: any;
  passwordConf: any;
  entityId: string;
}

export interface UserQuestionResponse {
  lessonID: number; // 1 - 25
  sectionID: number; // group of questions
  questionID: number; // actual question etc
  correctAnswers: Array<string>;
  answers: Object;
}

export interface Answer {
  blankID: string;
  correct: boolean;
  choice: string;
}
